import React from 'react';
import ProfileList from '../components/Profile/ProfileList';
import { Container } from '@mui/material';

const ProfilesPage: React.FC = () => (
  <Container maxWidth="md" sx={{ mt: 3 }}>
    <ProfileList />
  </Container>
);

export default ProfilesPage; 